/**
 * Description section: subtitle, description.
 */

import { type ReactNode } from "react";
import { InlineTextPreview } from "../InlineFields.tsx";
import { SmartSection } from "../SmartSection.tsx";

export interface DescriptionSectionProps {
  id: string;
  subtitle: string;
  description: string;
  setEditingField: (f: "subtitle" | "description" | null) => void;
  icon: ReactNode;
  summary: string;
  filledCount: number;
  totalCount: number;
  hint?: string;
}

export function DescriptionSection({
  id,
  subtitle,
  description,
  setEditingField,
  icon,
  summary,
  filledCount,
  totalCount,
  hint,
}: DescriptionSectionProps) {
  return (
    <SmartSection
      id={id}
      title="Описание"
      icon={icon}
      summary={summary}
      filledCount={filledCount}
      totalCount={totalCount}
      hint={hint}
      defaultOpen={false}
    >
      <div className="card overflow-hidden">
        <InlineTextPreview
          label="Подзаголовок"
          value={subtitle}
          placeholder="Добавить..."
          onClick={() => setEditingField("subtitle")}
        />
        <InlineTextPreview
          label="Описание"
          value={description}
          placeholder="Полное описание..."
          onClick={() => setEditingField("description")}
        />
      </div>
    </SmartSection>
  );
}
